<template>
  <div class="col-12">
    <div class="search-padd">
      <form v-on:submit.prevent>
        <div class="col-xs-12 override-padding">
          <div class="crm_admin_heading account_heading_1 text-left">+/-</div>
          <div class="crm_admin_heading account_heading_2 text-left">
            Account Name
          </div>
          <div class="crm_admin_heading account_heading_3 text-left">City</div>
          <div class="crm_admin_heading account_heading_4 text-left">State</div>
          <div class="crm_admin_heading account_heading_5 text-left">
            Postal Code
          </div>
          <div class="crm_admin_heading account_heading_6 text-left">Phone</div>
          <div class="crm_admin_heading account_heading_7 text-left">
            Status
          </div>
        </div>
        <div style="clear: both"></div>
        <div v-show="loading" class="loading_show">
          <div class="spinner-border text-danger"></div>
        </div>
        <div class="enterprise_account" id="account_details_more">
          <div
            class="
              crm_admin_field_lists
              account_heading_1
              text-center
              font-25
              line-height-30
            "
          >
            <a v-b-toggle="'collapse'">
              <span class="when-opened">-</span>
              <span class="when-closed">+</span>
            </a>
          </div>
          <div class="crm_admin_field_lists account_heading_2 text-left">
            <div class="search-padd">
              <input
                type="text"
                id="account_name"
                class="col-12 col-sm-12 ma-input-field"
                ref="account_name"
                name="account_name"
                v-model="enterprise_search_accounts[0].account_name"
                v-validate="{ rules: { required: true, regex: nameRegex() } }"
                placeholder="Account Name"
                maxlength="250"
              />
              <div
                v-if="verrors.firstByRule('account_name', 'required')"
                class="margin-bottom-5 validate-warning-msg"
              >
                Account name is required
              </div>
              <div
                v-if="verrors.firstByRule('account_name', 'regex')"
                class="margin-bottom-5 validate-warning-msg"
              >
                Account name should only contain - and _
              </div>
            </div>
          </div>
          <div class="crm_admin_field_lists account_heading_3 text-left">
            <div class="search-padd">
              <input
                type="text"
                id="account_city"
                class="col-12 col-sm-12 ma-input-field"
                ref="account_city"
                name="account_city"
                v-model="enterprise_search_accounts[0].account_city"
                v-validate="'required'"
                placeholder="City"
                maxlength="250"
              />
            </div>
          </div>
          <div class="crm_admin_field_lists account_heading_4 text-left">
            <div class="search-padd">
              <b-form-select
                class="custom-select ma-input-field"
                id="account_state"
                name="account_state"
                v-model="enterprise_search_accounts[0].account_state"
                :options="state_options"
              >
              </b-form-select>
            </div>
          </div>
          <div class="crm_admin_field_lists account_heading_5 text-left">
            <div class="search-padd">
              <input
                type="text"
                id="account_zipcode"
                class="col-12 col-sm-12 ma-input-field"
                ref="account_zipcode"
                name="account_zipcode"
                v-model="enterprise_search_accounts[0].account_zipcode"
                v-validate="{ rules: { regex: getPostalCodeRegex() } }"
                placeholder="Postal"
                maxlength="10"
              />
              <div v-if="verrors.has('account_zipcode')" class="margin-bottom-5 validate-warning-msg">Postal code is invalid</div>
            </div>
          </div>
          <div class="crm_admin_field_lists account_heading_6 text-left">
            <div class="search-padd">
              <input
                type="text"
                id="account_phone"
                class="col-12 col-sm-12 ma-input-field"
                ref="account_phone"
                name="account_phone"
                v-model="enterprise_search_accounts[0].account_phone"
                v-validate="{ rules: { regex: phoneRegex(), required: true } }"
                @keyup="phoneValid($event)"
                @blur="phoneValid($event)"
                placeholder="Phone No"
                maxlength="14"
              />
              <div
                v-if="verrors.firstByRule('account_phone', 'required')"
                class="margin-bottom-5 validate-warning-msg"
              >
                Phone number is required
              </div>
              <div
                v-if="verrors.firstByRule('account_phone', 'regex')"
                class="margin-bottom-5 validate-warning-msg"
              >
                Phone number is invalid
              </div>
            </div>
          </div>

          <div class="crm_admin_field_lists account_heading_7 text-left">
            <div class="search-padd">
              <b-form-select
                class="custom-select ma-input-field"
                name="account_status"
                id="account_status"
                v-model="enterprise_search_accounts[0].account_status"
                :options="account_status_options"
              >
              </b-form-select>
            </div>
          </div>
        </div>
        <div style="clear: both"></div>
        <b-collapse v-bind:id="'collapse'" class=""> </b-collapse>
        <div style="clear: both" class="margin-bottom-10"></div>
      </form>
    </div>
  </div>
</template>

<script>
import Vue from "vue/dist/vue.esm";
import axios from "axios";
import VeeValidate from "vee-validate";
import EventBus from "../../bus";
import Multiselect from "vue-multiselect";
import moment from "moment";
Vue.use(VeeValidate, { errorBagName: "verrors", fieldsBagName: "vfields" });

export default {
  props: ["accountId", "program", "accountStatus"],
  data() {
    return {
      enterprise_search_accounts: [
        {
          account_name: '',
          account_city: '',
          account_state: '',
          account_zipcode: '',
          account_phone: '',
          account_status: '',
        },
      ],
      loading: false,
      account_status_options: [
        { value: "", text: "Select Status" },
        { value: "Active", text: "Active" },
        { value: "Inactive", text: "Inactive" },
        { value: "Prospect", text: "Prospect" },
      ],
      state_options: [],
    };
  },
  components: {},
  methods: {
    nameRegex: function () {
      return /^[\w- ']*$/;
    },
    phoneValid: function (event) {
      var phone = this.enterprise_search_accounts[0].account_phone;
      this.enterprise_search_accounts[0].account_phone = phone
        .replace(/[^0-9]/g, "")
        .replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
    },
    phoneRegex: function () {
      return /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    },
    getPostalCodeRegex() {
      return /^[0-9]{5}(?:-[0-9]{4})?$/;
    },
    getStateLists: function (CountryCode) {
      axios
        .get("/get-state-lists/" + CountryCode, {})
        .then((response) => {
          this.state_options = response.data;
        })
        .catch(function (error) {});
    },
  },
  created() {
    this.getStateLists("US");
  },
};
</script>
<style scoped>
.account_heading_1 {
  width: 3%;
}
.account_heading_2 {
  width: 25%;
}
.account_heading_3 {
  width: 15%;
}
.account_heading_4 {
  width: 15%;
}
.account_heading_5 {
  width: 15%;
}
.account_heading_6 {
  width: 15%;
}
.account_heading_7 {
  width: 12%;
}
.ma-input-field {
  line-height: 30px;
  margin-bottom: 5px;
  padding: 0 5px;
  border: 0 none;
  color: #707070;
  min-height: 38px;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/enterprise_lookup_search_accounts_tab.vue